function normalizeRoleplayPreviewItem(source = {}) {
    return {
        key: source.key || '',
        title: source.title || 'Roleplay',
        description: source.description || '',
        image: source.image || '',
        characters: source.characters || '[]',
        profileUrl: source.profileUrl || '',
        adjustUrl: source.adjustUrl || '',
        startUrl: source.startUrl || source.profileUrl || '',
    };
}

function mergeRoleplayPreviewItems(primaryItems = [], secondaryItems = []) {
    const merged = [];
    const seen = new Set();

    [primaryItems, secondaryItems].forEach((items) => {
        (items || []).forEach((item) => {
            const normalizedItem = normalizeRoleplayPreviewItem(item);
            const key = normalizedItem.key || `${normalizedItem.title}|${normalizedItem.image}`;

            if (!normalizedItem.image || seen.has(key)) {
                return;
            }

            seen.add(key);
            merged.push(normalizedItem);
        });
    });

    return merged;
}

function createInitialRoleplayPreviewItems(feedItems = [], currentPreviewData = null) {
    return mergeRoleplayPreviewItems(
        currentPreviewData ? [currentPreviewData] : [],
        feedItems
    );
}

module.exports = {
    createInitialRoleplayPreviewItems,
    mergeRoleplayPreviewItems,
};
